import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';
import { useSelector } from 'react-redux';

function GlobalLoading({ showByProp, textByProp }) {
    const { showGlobalLoading, globalLoadingMessage } = useSelector((state) => state.uiReducer);
    const isOpen = showByProp !== undefined ? Boolean(showByProp) : Boolean(showGlobalLoading);
    const message = textByProp || globalLoadingMessage || "Cargando...";

    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Fade}
            transitionDuration={200}
            sx={{
                zIndex: 9999,
                '& .MuiPaper-root': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    overflow: 'hidden',
                    margin: 0,
                    maxWidth: 'none',
                },
                '& .MuiBackdrop-root': {
                    backdropFilter: 'blur(5px)',
                    backgroundColor: 'rgba(3, 13, 57, 0.35)',
                    transition: 'all 0.3s ease',
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '24px',
                    padding: '32px 40px',
                    boxShadow: '0 20px 50px rgba(3, 13, 57, 0.22)',
                    border: '1px solid rgba(226, 232, 240, 0.9)',
                    textAlign: 'center',
                    minWidth: '280px',
                    maxWidth: '380px',
                }}
            >
                <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2.5 }}>
                    {/* Background Spinner Ring */}
                    <CircularProgress
                        variant="determinate"
                        value={100}
                        size={56}
                        thickness={4}
                        sx={{ color: '#E2E8F0' }}
                    />
                    {/* Active Animated Spinner */}
                    <CircularProgress
                        variant="indeterminate"
                        disableShrink
                        size={56}
                        thickness={4}
                        sx={{
                            color: '#192873',
                            animationDuration: '900ms',
                            position: 'absolute',
                            left: 0,
                        }}
                    />
                </Box>

                <Typography
                    variant="h6"
                    sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        fontSize: '17px',
                        color: '#192873',
                        mb: 0.5,
                        letterSpacing: '-0.01em',
                    }}
                >
                    {message}
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: 'Roboto, sans-serif',
                        fontSize: '13px',
                        color: '#64748B',
                        fontWeight: 500,
                    }}
                >
                    Por favor espere un momento
                </Typography>
            </Box>
        </Dialog>
    );
}

export default GlobalLoading;